import store from "@/store";
import Vue from "vue";
// console.log(isMobile)
function setRem() {
  const htmlDom = document.documentElement;
  const htmlWidth = htmlDom.clientWidth;
  const htmlHeight = htmlDom.clientHeight;

  // 判断是否是移动设备
  const isMobile = /ipad|iphone|android|windows ce|windows mobile|ucweb|midp|rv:1.2.3.4/.test(
    navigator.userAgent.toLowerCase()
  );

  let fontSize;
  if (isMobile) {
    fontSize = htmlWidth / 7.5;
  } else {
    // 默认 fontSize 为 51.2，针对不同屏宽设置不同值
    if (htmlWidth < 260) {
      fontSize = 34.2;
    } else if (htmlWidth < 320) {
      fontSize = 38.2;
    } else if (htmlWidth < 380) {
      fontSize = 45.2;
    } else {
      fontSize = 51.2;
    }
  }

  htmlDom.style.fontSize = `${fontSize}px`;

  // 设置 Vue 全局 rem 转换函数
  Vue.prototype.remUnit = 200;
  Vue.prototype.remTran = (value) => Number(value) / Vue.prototype.remUnit;

  // 添加到 body 属性和 Vuex
  document.body.setAttribute("data-mobile", isMobile);
  store.commit("wallet/setIsMobile", isMobile);
  store.commit("wallet/setHtmlSize", { w: htmlWidth });

  console.log("setRem:", { htmlWidth, htmlHeight, isMobile, fontSize });
}


function throttle(fn, delay) {
  var timer = null;
  return function () {
    var context = this,
      args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function () {
      fn.apply(context, args);
    }, delay);
  };
}

// 初始化
setRem(true);
// 改变窗口大小时重新设置 rem

window.addEventListener("resize", throttle(setRem, 0));

export default setRem
